module.exports = __webpack_public_path__ + "static/media/in.6e52600b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Person/components/Social/in.svg
// module id = 108
// module chunks = 0